/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * StudentAssignmentPerformance
 *
 * @file StudentAssignmentPerformanceStyle.jsx
 * @author Mohamed yasar arabath M
 * @since 1.0.0
 */
import { styled } from '@mui/material/styles';
import { Button, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import mixins from '../../../assets/styles/mixins.scss';
import CommonStyles from '../../../assets/styles/CommonStyles';

const {
  subtitle2
} = CommonStyles();

export const Subtitle2 = styled('span')({
  '&&': subtitle2
});

export const BackButton = styled(Button)({
  '&&': {
    color: mixins.color_text_primary,
    fontFamily: "'PlusJakartaSans-SemiBold', sans-serif",
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600,
    minWidth: 'unset',
    width: 'fit-content',
    borderRadius: 24,
    '& span': {
      minWidth: 'unset'
    }
  }
});

export const Root = styled('div')({
  '&&': {
    display: 'flex',
    flexDirection: 'column',
    gap: 16
  }
});

export const RowSpaceBetween = styled('div')({
  '&&': {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});

export const SecondaryBodyText = styled(Typography)({
  '&&': {
    color: mixins.color_text_secondary,
    lineHeight: mixins.lineHeight143
  }
});

export const WrapperCardContainer = styled('div')({
  '&&': {
    display: 'flex',
    flexDirection: 'row',
    gap: 16
  }
});

export const FlexGrow = styled('div')({
  '&&': {
    flexGrow: 1,
    flexBasis: '50%'
  }
});

export const TopicsCoveredLabel = styled(Typography)({
  '&&': {
    color: '#171717',
    fontFamily: "'PlusJakartaSans-SemiBold', sans-serif",
    fontSize: 16,
    lineHeight: '24px',
    fontWeight: 600
  }
});

export const ScrollBox = styled('div')({
  '&&': {
    padding: '8px 0',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    maxHeight: 200,
    overflow: 'auto'
  }
});

export const Title = styled('span')({
  '&&': {
    color: mixins.color_text_primary,
    fontFeatureSettings: '\'liga\' off',
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize28,
    fontStyle: 'normal',
    fontWeight: mixins.fontWeight500,
    lineHeight: '128.571%',
    letterSpacing: '-0.56px'
  }
});

export const AssignmentNameContainer = styled('div')({
  '&&': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8
  }
});

export const CheckIcon = styled(CheckCircleIcon)({
  '&&': {
    color: '#37B866',
    verticalAlign: 'middle',
    marginRight: 4,
    width: 18,
    height: 18
  }
});

export const ErrorIcon = styled(ErrorOutlineIcon)({
  '&&': {
    color: '#FFAB00',
    verticalAlign: 'middle',
    marginRight: 4,
    width: 18,
    height: 18
  }
});
